import { PropsWithChildren } from 'react'

export type ModalProps = PropsWithChildren<{
  dismissable?: boolean
}>

export type ModalRegisterFunctions = {
  showModal: (params: ModalProps) => void
  hideModal: () => void
}

export class ModalManager {
  modalFunctions: ModalRegisterFunctions | null = null

  static instance: ModalManager

  static getInstance() {
    if (!ModalManager.instance) {
      ModalManager.instance = new ModalManager()
    }
    return ModalManager.instance
  }

  static register(functions: ModalRegisterFunctions) {
    ModalManager.getInstance().modalFunctions = functions
  }
  static show(params: ModalProps) {
    ModalManager.getInstance()?.modalFunctions?.showModal({ ...params })
  }

  static hide() {
    ModalManager.getInstance()?.modalFunctions?.hideModal()
  }
}
